
import React, { useEffect, useState } from "react";
import Axios from 'services/BackendApi/BackendApi';
import { Button } from "react-bootstrap";
import app_params from "modules/search/config/params";
import { searchService } from "services/BackendApi/searchService";
import SearchBarWidget from "modules/search/components/SearchBar/SearchBar";
import { Trash3, EyeFill, ArrowUpCircle, ArrowDownCircle } from "react-bootstrap-icons";
import ShareModal from "modules/search/components/ShareModal/ShareModal";
import SearchFilters from "modules/search/components/SearchFilters/SearchFilters";
import FiltersModal from "modules/search/components/FiltersModal/FiltersModal";
import { searchResultDummy } from "modules/search/dummy/searchresult";
import LoadingBox from "modules/search/components/LoadingBox/LoadingBox";
import MessageBox from "modules/search/components/MessageBox/MessageBox";
import styles from './ExpedienteView.module.scss'
import Modal from 'react-bootstrap/Modal';
import { isDisabled } from "@testing-library/user-event/dist/utils";
import SpinnerIcon from 'assets/img/loading'
import TemporaryFileViewer from "common/components/TemporaryFileViewer/TemporaryFileViewer";

export default function ExpedienteView() {
    const [lista, setLista] = useState([]);
    const [total, setTotal] = useState(0);
    const [id, setId] = useState(19);
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [tipo, setTipo] = useState();
    const [texto, setTexto] = useState([]);
    const [history, setHistory] = useState();
    // const [selectedItems, setSelectedItems] = useState(() => {
    //     const savedItems = localStorage.getItem('selectedItems');
    //     return savedItems ? JSON.parse(savedItems) : {};
    // });
    const bearer = localStorage.getItem("userInfo");
    const [items, setItems] = useState([]);
    const [sortedItems, setSortedItems] = useState({});
    const token = JSON.parse(bearer).access_token;
    const handleClose = () => setShow(false);

    const modalClose = () => setOpen(false);


    async function modalOpen(name) {
        const res = await Axios.ValidarLote({ urlParams: '1' });
        // console.log(res)
        setTexto(res?.data)
        setOpen(true)
        setTipo(name)
    };

    // useEffect(() => {
    //     console.log(selectedItems)
    //     Object.keys(selectedItems).forEach((key, index) => {
    //         // Asignamos el índice actual a la propiedad 'position' del objeto
    //         selectedItems[key].position = index;
    //     });
    //     setItems(selectedItems)
    //     console.log(selectedItems)
    //     localStorage.setItem('selectedItems', JSON.stringify(selectedItems))
    // }, [selectedItems]);


    async function History() {
        const res = await Axios.GetDossierHistory({ urlParams: "1" });
        console.log(res);
        setHistory(res.data)
    }

    useEffect(() => {
        const storedItems = localStorage.getItem('items');
        console.log(storedItems)
        setItems(JSON.parse(storedItems));
        // }
        History()
    }, []);


    const swapPositions = (currentKey, direction) => {
        // const newItems = { ...items };
        const index = items.findIndex(item => item.id === currentKey.toString());
        // console.log(newItems)
        let newIndex = null;
        if (direction === 'up') {
            if (currentKey > 0) {
                newIndex = index - 1
            }
        } else if (direction === 'down') {
            newIndex = index + 1
        }
        const newItems = [...items];
        if (newIndex != null) {
            [newItems[index], newItems[newIndex]] = [
                newItems[newIndex],
                newItems[index],
            ];
            console.log(newItems)
            setItems(newItems);
            // localStorage.setItem('items', JSON.stringify(items)) 
        }

    };

    useEffect(() => {
        localStorage.setItem('items', JSON.stringify(items));
        History()
    }, [items]);

    async function generatePdf() {
        console.log(items)
        // console.log(sortedEntries)
        if (items.length === 0) {
            console.log('Expediente vacio')
        }
        setLoading(true)
        if (name == '') {
            setName('Documento')
        }
        const res = await Axios.GenerateDossier({ array: JSON.stringify(items), name: name });
        console.log(res);
        if (res.data != null) {
            await Axios.UnificarPDF({ urlParams: { id: res.data.hash } });
            setId(res.data.id)
            checkStatus(res.data.hash)
        }
    }

    async function checkStatus(hash) {
        const data = await Axios.GetDossierStatus({ urlParams: { id: hash } });
        // console.log(data);
        let status = data.data.status;
        if (status == false) {
            setTimeout(() => { checkStatus(hash); }, 1000);
        } else {
            setTimeout(() => {
                setLoading(false)
                setShow(true)
                setName('')
                setItems([])
            }, 5000);

        }

    }

    function View(id) {
        setId(id)
        setShow(true)
    }

    async function deleteDossier() {
        // localStorage.removeItem("items")
        setItems([])
    }


    const DeleteItem = (id) => {
        if (items.some(item => item.id === id)) {
            const updatedItems = items.filter(item => item.id !== id);
            setItems(updatedItems);
        }
    };



    const expediente = [
        {
            id: 1,
            end_time: '2024-09-03 20:28:29',
            template: 'archivo'
        },
        {
            id: 2,
            end_time: '2024-09-03 20:21:38',
            template: 'archivo'
        },
        {
            id: 3,
            end_time: '2024-08-30 19:01:53',
            template: 'archivo'
        }
    ]



    return (
        <>
            <h2>Mi expediente</h2>
            <br />
            <div className="row">

                <div className="col-6">

                    <div className="col-12">
                        {items?.map((item,index) => (
                            <>
                                <div className="row">
                                    <div className="col-11">
                                        <div className="card mb-3" >
                                            <div className="card-header">
                                                <div className="d-flex flex-row justify-content-between">
                                                    <div>
                                                        <h5>
                                                            <b>Item:</b> {item?.title}
                                                        </h5>
                                                    </div>
                                                    <h5>
                                                        <span className={styles.trash} onClick={() => DeleteItem(item?.id)}>
                                                            <Trash3 />
                                                        </span>
                                                    </h5>
                                                </div>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-10 col-lg-8 mb-2">
                                                        <div>
                                                            <b>Tipo de documento: </b>
                                                            {item?.doctype}
                                                        </div>
                                                        <span className="me-2">
                                                            <i className="fas fa-globe-americas"></i>
                                                        </span>
                                                    </div>
                                                    <div className="col-2 d-none d-lg-flex flex-column justify-content-start">
                                                        <a href={`${app_params.basepath}/view/false/${item?.title}`} className="text-decoration-none" target="_blank">
                                                            <Button className={styles.view}>
                                                                Ver Documento
                                                            </Button>
                                                        </a>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-1">
                                        <div className={styles.arrow}>
                                        {(index!=0) &&
                                            <span  onClick={() => swapPositions(item.id, 'up')}>
                                                <ArrowUpCircle size={20} />
                                            </span>
                                        }
                                        <br />
                                        {(index<items.length-1) &&
                                            <span  onClick={() => swapPositions(item.id, 'down')}>
                                                <ArrowDownCircle size={20} />
                                            </span>
                                        }
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>

                </div>
                <div className="col-3">
                    <div className="row">
                        <h3>Historial:</h3>
                        <div className={styles.history}>
                            <div className="col-12">

                                {history?.map((item, idx) => {
                                    return <div className="card mb-3" >
                                        <div className="card-header">
                                            <div className="d-flex flex-row justify-content-between">
                                                <div>
                                                    <b>Expediente:</b> {item?.name}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-12 col-lg-10 mb-2">
                                                    <div>
                                                        <b>Realizado el : </b>
                                                        {item?.end_time}
                                                    </div>
                                                    <span className="me-2">
                                                        <i className="fas fa-globe-americas"></i>
                                                    </span>
                                                </div>
                                                <div className="col-2 d-none d-lg-flex flex-column justify-content-start">
                                                    <Button className={styles.view} onClick={() => View(item?.id)}>
                                                        <EyeFill />
                                                    </Button>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-3">
                    <input
                        style={{ height: '40px', paddingLeft: '10px' }}
                        type="text"
                        className={`form-control`}
                        placeholder="Nombre del Documento"
                        aria-label="Buscar"
                        aria-describedby="basic-addon2"
                        id="name"
                        name="name"
                        autoComplete="off"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <br />
                    <div className={styles.actions}>

                        <Button className={styles.buttons} variant="warning" onClick={() => generatePdf()} disabled={items?.length === (0||1) ? true : false}>
                            {(loading) ? <>{'Cargando...   '}<SpinnerIcon /></> : 'Generar'}</Button>
                        <Button className={styles.buttons} variant="danger" onClick={() => deleteDossier()} disabled={items?.length === 0 ? true : false}>Borrar Expediente</Button>
                    </div>


                </div>
            </div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Archivo Unificado</Modal.Title>
                </Modal.Header>
                <Modal.Body className={styles.columna}>
                    <TemporaryFileViewer pdf={id} grantKey={token} />
                </Modal.Body>
            </Modal>
        </>
    );

}